import React, { FC, ReactNode } from 'react'
import { LinearProgress, makeStyles } from '@material-ui/core'
import { useRouteLoadingIndicator } from '../../lib/useRouteLoadingIndicator'
import classnames from 'classnames'

const useStyles = makeStyles(
  (_theme) => ({
    root: {
      opacity: 1,
      transition: 'opacity 0.4s',
      '&.route-loading': {
        opacity: 0.3,
      },
    },
    linearProgressWrapper: {
      position: 'relative',
      '& .MuiLinearProgress-root': {
        position: 'absolute',
        width: '100%',
      },
    },
  }),
  { name: 'RouteLoadingIndicator' },
)

const RouteLoadingIndicator: FC<{
  className?: string
  children: ReactNode
}> = ({ className, children }) => {
  const classes = useStyles()
  const { loading } = useRouteLoadingIndicator()
  return (
    <>
      {loading && (
        <div className={classnames(classes.linearProgressWrapper, className)}>
          <LinearProgress />
        </div>
      )}
      <div
        className={classnames(
          classes.root,
          loading ? 'route-loading' : 'route-loaded',
          className,
        )}
      >
        {children}
      </div>
    </>
  )
}

export default RouteLoadingIndicator
